export const environment = {
  production: false,
  apiURL: 'https://api.tecnologiaasap.com.br',
  baseURL: 'https://api.tecnologiaasap.com.br',
  filestack: {
    key: 'AD5oDjsJaTJOzLe1Llj9mz'
  },
  pusher: {
    key: 'eaf41725f3b027147953',
  },
  firebase: {
    apiKey: 'AIzaSyCnQ7hg9qn8mrS3zSLX-xeXX3wKbuC2GXA',
    authDomain: 'admin-17e4f.firebaseapp.com',
    databaseURL: 'https://admin-17e4f.firebaseio.com',
    projectId: 'admin-17e4f',
    storageBucket: 'admin-17e4f.appspot.com',
    messagingSenderId: '572223664609'
  },
  eventPlatform: '/events'
};
